import { render, staticRenderFns } from "./text-field-primary.vue?vue&type=template&id=766848d7&scoped=true"
import script from "./text-field-primary.vue?vue&type=script&lang=js"
export * from "./text-field-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766848d7",
  null
  
)

export default component.exports